import { ServiceType } from "@/types/generals";

const getEnvVar = (key: string, fallback = ""): string => {
  const value = process.env[key];
  if (typeof value === "undefined") {
    console.warn(`⚠️ Warning: Environment variable ${key} is not set`);
  }
  return value || fallback;
};

export const env = {
  ENV: getEnvVar("REACT_APP_BILLET_ENVIRONMENT"),
  API_URL: getEnvVar("REACT_APP_API_URL"),
  API_URL_NEW: getEnvVar("REACT_APP_API_URL_NEW"),
  API_URL_COMMERCE: getEnvVar("REACT_APP_API_COMMERCE_URL"),
  API_URL_PAYMENT_LINK: getEnvVar("REACT_APP_API_URL_PAYMENT_LINK"),
  API_KEY_PAYMENT_LINK: getEnvVar("REACT_APP_API_KEY_PAYMENT_LINK"),
  MAPS_API_KEY: getEnvVar("REACT_APP_MAPS_API_KEY"),
  COGNITO_USER_POOL_ID: getEnvVar("REACT_APP_COGNITO_USER_POOL_ID"),
  COGNITO_USER_POOL_CLIENT_ID: getEnvVar(
    "REACT_APP_COGNITO_USER_POOL_CLIENT_ID"
  ),
  COGNITO_DOMAIN: getEnvVar("REACT_APP_COGNITO_DOMAIN"),
  REDIRECT_SIGNIN: getEnvVar("REACT_APP_REDIRECT_SIGNIN"),
  REDIRECT_SIGNOUT: getEnvVar("REACT_APP_REDIRECT_SIGNOUT"),
  GW_API_REQ: getEnvVar("REACT_APP_GW_API_REQ"),
  APP_VERSION: getEnvVar("REACT_APP_VERSION"),
  API_PUBLIC_PROVIDER_URL: getEnvVar("REACT_APP_API_PUBLIC_PROVIDER_URL"),
  API_PUBLIC_PROVIDER_KEY: getEnvVar("REACT_APP_API_PUBLIC_PROVIDER_KEY"),
};

export const getBaseURL = (service: ServiceType): string => {
  switch (service) {
    case "paymentLink":
      return env.API_URL_PAYMENT_LINK;
    case "commerce":
      return env.API_URL_COMMERCE;
    case "public-provider":
      return env.API_PUBLIC_PROVIDER_URL;
    default:
      return env.API_URL;
  }
};

export const getRequiredHeader = (
  service: ServiceType
): Record<string, string> => {
  const headers: Record<string, string> = {};

  if (service === "public-provider") {
    headers["x-api-key"] = env.API_PUBLIC_PROVIDER_KEY;
    headers["Content-Type"] = "application/json";
  }

  return headers;
};
